import { render, staticRenderFns } from "./GoodsPreview.vue?vue&type=template&id=3cc6ec0b&scoped=true&"
import script from "./GoodsPreview.vue?vue&type=script&lang=js&"
export * from "./GoodsPreview.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPreview.vue?vue&type=style&index=0&id=3cc6ec0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6ec0b",
  null
  
)

export default component.exports